export const SET_SELECTED_RETURNS = 'SET_SELECTED_RETURNS';
export const setSelectedReturns = (selectedReturnIds) => ({
  type: SET_SELECTED_RETURNS,
  selectedReturnIds,
});
